module.exports = __webpack_public_path__ + "img/gather_skirt.aa26dfcb.png";